import React from "react";

const SelectedToggleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="22"
      viewBox="0 0 44 22"
      fill="none"
    >
      <rect
        x="0.5"
        y="0.5"
        width="43"
        height="21"
        rx="3.5"
        stroke="url(#paint0_linear_5958_9101)"
      />
      <rect
        x="25"
        y="4"
        width="14"
        height="14"
        rx="2"
        fill="url(#paint1_linear_5958_9101)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5958_9101"
          x1="22"
          y1="0"
          x2="22"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#05BAA4" />
          <stop offset="1" stopColor="#288BCE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5958_9101"
          x1="32"
          y1="4"
          x2="32"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#05BAA4" />
          <stop offset="1" stopColor="#288BCE" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SelectedToggleIcon;
